<script>
    import BlogSummary from '../components/BlogSummary.svelte';
    export let short = false;
    export let blogUrl = "nilkan-liikkuvuus-ja-huolto-osa2";
    let title = "Nilkan liikkuvuus ja huolto, osa 2";
    let author = "Petteri";
    let blogDate = "16.10.2016";
    let titlePic = "nilkat-2.png";
    let firstPara = "Nilkkakirjotuksen ensimmäisessä osassa kerroin nilkan liikkuvuuden tärkeydestä " +
        "sekä mikä huonoon liikkuvuuteen on mahdollisesti ajanut. " +
        "Tässä osassa pääsemme mittaamaan nilkan nykyhetken tilanteen ja käärimään hihat liikkuvuusmörön nujertamiseksi.";

</script>
<!--  Blogi koostuu kahdesta osasta. Eka osa "short" on siis muille siuville tuleva lyhennelmä, jossa on artikkelikuva ja lyhyt teksti -->

{#if short}
<BlogSummary blogPath={blogUrl} title={title} titlePic={titlePic} blogDate={blogDate} firstPara={firstPara}></BlogSummary>

{:else}
    <div class="blog page">
        <article class="container">
            <h1>{title}</h1>
            <div class="blogDate">{author} | {blogDate}</div>
            <div class="blogMainImage" style="background-image: url('/svelte-site/img/blog/{titlePic}')"></div>
            <p>Nilkkakirjotuksen <a href="https://www.dynamosali.com/blog/nilkan-liikkuvuus-ja-huolto-osa1/">ensimmäisessä
                 osassa</a> kerroin nilkan liikkuvuuden tärkeydestä sekä mikä huonoon liikkuvuuteen on mahdollisesti ajanut.                
                 Tässä osassa pääsemme mittaamaan nilkan nykyhetken tilanteen ja käärimään hihat liikkuvuusmörön nujertamiseksi.</p>


            <h4>Liikkuvuustestit</h4>

            <p>Näillä muutamilla testeillä voit mitata, missä olet menossa. Testejä, kuten vaikka pistoolikyykkyä, on
                hyvä kokeilla aika-ajoin. Mikäli et esimerkiksi yhtäkkiä pysykään kyykyssä, voit reagoida uuteen
                tilanteeseen heti. Toinen vaihtoehto on antaa jumin vallata pikkuhiljaa kroppaa, kunnes eräänä aamuna
                havahdut kolotuksiin eri puolella vartaloa. Tyypillisin selitys tässä tilanteessa on "ei sitä enään näin
                vanhana taivu..".</p>

            <p>Suorita testit ilman kenkiä, eli avojaloin tai sukat jalassa.</p>

            <h5>Keppitesti</h5>
            <p>Seiso korkeassa polviasennossa, eli takimmaisen jalan polvi ja etummaisen jalkapohja maassa. Laita keppi
                pystyyn etummaisen jalan pikkuvarpaan eteen. Pidä keppi pystyssä, ja lähde polvella nojaamaan eteenpäin
                kohti keppiä. Ohita keppi polvella ulkopuolelta, jos saat. Nojaa niin paljon eteen kuin mahdollista
                niin, että kantapää pysyy maassa.</p>
            <p>Tulos:</p>
            <ul>
                <li>Polvi ei yllä keppiin = "<a href="https://fi.wikiquote.org/wiki/Hugo">Herää pahvi</a>", tarttis
                    tehdä jotain.
                </li>
                <li>Polvi yltää kepin viereen = Melkein hyvä, mutta ei ihan vielä siellä.</li>
                <li>Keppi asettuu säären puolivälin kieppeille = Erinomaista. Jatka samaa rataa.</li>
            </ul>

            <h5>Syväkyykky</h5>

            <p>Kokeile, pääsetkö syväkyykkyyn. Syväkyykky toki mittaa myös lantion liikkuvuutta, mutta nilkkojen
                liikkuvuudella on siinä iso rooli. Seiso noin hartioiden levyisessä asennossa. Lähde laskeutumaan alas,
                ikään kuin istuisit penkille niin, että painopisteesi pysyy jalkojen välissä. Pidä samalla selkä
                suorassa. Jatka laskeutumista ilman, että kantapäät irtoavat maasta. Levitä samalla polvia sivuille
                niin, että pääset laskeutumaan jalkojen “väliin”. Mikäli pääset ihan pohjalle saakka, on liikkuvuutesi
                hyvä.</p>

            <h5>Pistoolikyykky</h5>

            <p>Eriparia olevat nilkat heijastuvat pikkuhiljaa ongelmina alaselän kautta aina hartioihin saakka. </p>

            <p>Pistoolikyykyllä on helppo varmistaa nilkan liikkuvuuden mahdolliset puolierot. Pistoolikyykyssä
                laskeudutaan ilman lisäpainoa yhden jalan varassa niin alas, että pakara osuu akillesjänteeseen. Voit
                laskeutumisvaiheessa ottaa tukea jostain. Pystytkö tasapainottelemaan toinen jalka ilmassa tässä
                asennossa? Jos kaadut taaksepäin, tarkoittaa se, että nilkkasi ei antanut periksi, jotta olisit voinut
                viedä painopistettäsi tarpeeksi eteen.</p>

            <h5>Passiivinen liikkuvuus</h5>

            <p>Passiiviseen liikkuvuustestiin tarvitset avustajan. Asetu selinmakuulle jalat suorana. Avustaja ottaa
                hyvän otteen jalkaterästä ja painaa kädellään jalkaterää kohti säärtä. Merkki hyvästä liikkuvuudesta on,
                että jalkaterän ja nilkan välinen kulma on noin 40-45 astetta.

            <h4>Take my money! What do I do??</h4>

            <p>No wörries. Vaikka nilkkasi olisi mallia <a
                    href="http://www.snowshoemag.com/wp-content/uploads/Pauline-with-mattock.jpg">mummon kuokka</a>,
                ei peli ole vielä välttämättä menetetty. Mikäli jumia on hartaudella useita vuosia kerätty, ei jumi ja
                liikkuvuus tule kuin taikaiskusta takaisin yhdellä kehonhuoltokerralla.</p>

            <p>Kun käärit hihat liikkuvuuden takaisinsaamiseksi, ei hommaa kannata heittää kesken kovin helposti.
                Keskushermostomme nimittäin muistaa vanhan liikeradan ja palaa siihen mielellään hyvin pian. Tämän
                vuoksi liike tulee opettaa kropallemme yhä uudestaan.</p>

            <p>Kehonhuollossa maltti on valttia. Lihakset voivat sopeutua uuteen liikkeeseen jo kuukaudessa, mutta
                jäykältä niveleltä ja sidekudokselta siihen voi mennä useita kuukausia. Ei siis kannata heittää sitä
                mummon kuokkaa kaivoon heti ensimmäisten viikkojen jälkeen.</p>

            <h4>Pehmytkudoshoito</h4>

            <p>Mikäli pohkeesi ovat kuin kreikkalaisella veistoksella, eli kivikovat, kannattaa niitä pehmittää ennen
                venyttämistä. Nilkan ja säären lihaksia voi möyhentää pallolla tai putkirullalla. Asetu lattialle
                istumaan jalat suorina ja hierottava jalka alimmaisena. Laita rulla alemman jalan pohkeen alle, ja ala
                rullata hitaasti nilkasta kohti polvitaivetta. Voit myös keinutella puolelta toiselle. Kun löydät kovan
                ja kipeän paikan, voit viipyä siinä hetken. Pesäpallon tai lacrossepallon avulla saat pistemäisemmän
                hieronnan aikaiseksi, ja pääset syvemmälle lihakseen. Muista hieroa myös säären sivuja ja etuosaa.</p>

            <p>Pohkeita voi hieroa myös ihan ilman välineitä. Asetu polvilleen maahan ja laita jalat ristiin niin, että
                pohkeet ovat päällekkäin. Istu sitten varovasti alas, ja voit tuntea, miten makeasti päällimmäisen jalan
                sääri hieroo alemman jalan pohjetta.</p>

            <img src="/svelte-site/img/blog/hieronta_istuen-710x375.png"
                 alt="Pohkeen hieronta istuen" width="600" height="400"/>

            <h4>Venyttelyt</h4>

            <p>Pohkeita voit venyttää joko seisten tai lattialla. Esimerkiksi lattialla menemällä A-asentoon kädet
                maassa. Nosta sitten toinen jalka irti lattiasta, ja laske se venytettävän jalan päälle. Suorista
                venytettävä jalka, rentouta pohje ja päästä kantapää tippumaan kohti lattiaa.</p>

            <p>Myös syväkyykyssä voi venyttää pohkeita. Asetu kyykkyyn, ja lähde viemään painoa selvästi toisen jalan
                päälle. Tässä voit ottaa käteen jonkin painon, jos haluat vieläkin voimakkaamman venytyksen. </p>

            <p>Erittäin hyvä venytys, ja oma suosikki, on asettaa tanko polvien päälle kyykkyasennossa. Aluksi on hyvä
                aloittaa tyhjällä tangolla, mutta lisää painoja kun venytysliike tulee tutummaksi.</p>

            <h4>Mites tästä eteenpäin</h4>

            <p>Liikkuvuushuoltoa kannattaa tehdä pitkin päivää ihan vaan pyörittelemällä nilkkaa seisaaltaan
                ääriasennosta toiseen. Tämä on helppo toteuttaa työpäivän aikana aina silloin tällöin. Myös
                kyykkyasentoa kannattaa kokeilla päivän aikana. Katso vaikka päivän sää kyykkyasennossa.</p>

            <p>Varsinaisia rullauskertoja ja pitkiä venytyksiä kannattaa ottaa omana kehonhuoltokertanaan tapauksesta
                riippuen kerran tai pari viikossa. Ennen urheilusuoritusta pitkiä venytyksiä ei kannata tehdä.
                Urheilusuorituksen jälkeen kehonhuoltoa voi tehdä, mutta parhaimman hyödyn saa varaamalla huollolle
                täysin oman aikansa.</p>

            <p>Rullauksen nyrkkisääntönä on, että aloita rullaus alhaalta ja hiero sydäntä kohti. Yhdellä huoltokerralla
                rullailua ja venyttelyä voi tehdä niin kauan, että kokee sen tehoavan ja sillä on vaikutusta. Aluksi voi
                olla, että yhteen huoltokertaan täytyy uhrata enempikin aikaa, ja huoltokertoja täytyy varata tiheämmin
                kalenteriin. Kun liikkuvuus on saavutettu, on sitä helpompi ylläpitää.</p>

            <p>Jos omista rullailuista tai venytysyrityksistä huolimatta nilkkaan ei tule lisää liikelaajuutta,
                venytyksissä nivelissä tuntuu kipua tai nivelet tuntuvat ottavan niin sanotusti “luu luuta vasten”
                kannattaa hakea apua ammattilaiselta. Osaava hieroja, fysioterapeutti tai osteopaatti osaa tulkita
                tilanteen vakavuuden ja tehdä tarvittavat hoitotoimenpiteet. Todella jäykissä tapauksissa hoito voi
                vaatia säännöllisiä käyntejä kuukausien ajan, jotta jumit alkavat antaa pikkuhiljaa periksi.</p>

            <iframe width="560" height="315" src="https://www.youtube.com/embed/LOge3GdMjM0"
                    title="YouTube video player" frameborder="0"
                    allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                    allowfullscreen></iframe>

            <p>--<br>
                Petteri</p>

            </article>


            <section class="container">
                <h2>Lue seuraavaksi</h2>
                <div class="row">
                    <article class="blog col-xs-12 col-md-4">
                        <BlogSummary blogPath='juoksuvoimaa_lihaskuntoharjoittelusta' 
                        title='Juoksuvoimaa lihaskuntoharjoittelusta' titlePic='2018/juoksutreenit.jpg' firstPara='Lihasten toimintakyky on kestävyyslajeissa oleellisessa roolissa ja vahva jaksaa pidemmälle. Voimaa tarvitaan niin eteenpäin vievään liikkeeseen kuin hyvän ryhdin ylläpitämiseen.' blogDate=''></BlogSummary>
                    </article>
                    <article class="blog col-xs-12 col-md-4">
                        <BlogSummary blogPath='selkavaivat_kuriin_treenaamalla' title='Selkävaivaisena treenaamisesta' 
                        titlePic='2014/levytanko.jpg' firstPara='Selkävaivat ovat nykyisin valitettavan yleisiä. Tilastojen mukaan vähintään joka kolmas suomalainen sanoo kärsineensä selkävaivoista viimeisen puolen vuoden aikana. Yleisimmit kivut esiintyvät alaselän alueella.' blogDate=''></BlogSummary>
                    </article>
                    <article class="blog col-xs-12 col-md-4">
                        <BlogSummary blogPath='vastuskuminauhat_6_vinkkia' title='6 vinkkiä vastuskuminauhojen hyödyntämiseen' titlePic='2014/etunojapunnerrus2.jpg' firstPara='Vastuskuminauhat ovat hauska ja tehokas tapa tuoda monipuolisuutta ja vaihtelua harjoitteluun. Lue tästä vinkit vaskuskuminauhojen hyödyntämiseen treeneissä.' blogDate=''></BlogSummary>
                    </article>
                </div>
            </section>

    </div>
{/if}

<style>


</style>